import { EntityFilter } from '@backstage/plugin-catalog-react'
import { Entity } from '@backstage/catalog-model'

export class EntityDatabaseTypeFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  filterEntity(entity: Entity): boolean {
    const dbRef = entity.metadata.annotations?.['sennder.com/database-type'] as
      | string
      | undefined
    return dbRef ? this.values?.includes(dbRef) : false
  }

  toQueryValue(): string[] {
    return this.values
  }
}

export class EntityQueueTypeFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  filterEntity(entity: Entity): boolean {
    const qsRef = entity.metadata.annotations?.['sennder.com/queue-type'] as
      | string
      | undefined
    return qsRef ? this.values?.includes(qsRef) : false
  }

  toQueryValue(): string[] {
    return this.values
  }
}
